import { CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './sic-button.css.lit';

import { html } from 'lit/static-html.js';

import { OutlineElement } from '../../base/outline-element/outline-element';

import { wrapLastWord } from '../../../utilities/wrap-last-word';
import { checkFileType } from '../../../utilities/check-file-type';
import { externalLinkText } from '../../../utilities/external-link-text';

/**
 * The button component.
 * @element sic-button
 * @slot defaultSlot
 * You can also set a min-width on the button container to prevent the button text from shrinking too much.
 *
 * Lightdom styles in sic-button.lightdom.css included in /shared.css
 */
@customElement('sic-button')
export class SicButton extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Default Icon.
   */
  @property({ type: Boolean, attribute: 'default-icon' })
  defaultIcon = false;

  connectedCallback(): void {
    super.connectedCallback();
    this?.querySelector('a')?.classList.add('sic-btn');
    this?.querySelector('button')?.classList.add('sic-btn');

    const element = this.querySelector('.sic-btn');
    const elementTarget = element?.getAttribute('target');

    checkFileType(element as HTMLElement);
    // The purpose of this block of code is to attach on icon to the last word.
    // sic-button only has an icon if it's an external link so we target that specifically.
    if (elementTarget === '_blank') {
      // Wraps last word in a span.last-word element.
      // span.last-word is where the icon is added via pseudo
      wrapLastWord(element as HTMLElement);

      // Adds external link text for screen readers.
      externalLinkText(element as HTMLElement);
    }
  }

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-button': SicButton;
  }
}
